import { Card, Text } from '@billda/design-system';
import { format, parseISO } from 'date-fns';
import { LabelValueRow } from './LabelValueRow';

interface PotSummaryCardProps {
  ownerType: 'Gang' | 'Solo';
  ownerName: string;
  period: {
    weekNumber: number;
    year: number;
    start: string;
    end: string;
  };
}

export function PotSummaryCard({
  ownerType,
  ownerName,
  period,
}: PotSummaryCardProps) {
  const formatDateRange = (start: string, end: string) => {
    const startDate = parseISO(start);
    const endDate = parseISO(end);
    const startFormatted = format(startDate, 'dd MMM');
    const endFormatted = format(endDate, 'dd MMM yyyy');
    return `${startFormatted} - ${endFormatted}`;
  };

  return (
    <Card className="p-4">
      <Text variant="h6" className="mb-2">
        Summary
      </Text>
      <div className="flex flex-col gap-4">
        <LabelValueRow
          label={ownerType === 'Gang' ? 'Gang' : 'Worker'}
          value={ownerName}
          valueWeight="medium"
        />
        <LabelValueRow
          label="Period"
          value={`Week ${period.weekNumber}, ${period.year}`}
        />
        <LabelValueRow
          label="Dates"
          value={formatDateRange(period.start, period.end)}
        />
      </div>
    </Card>
  );
}
